import React from "react";

const SinglePlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <clipPath id="clipPath8746628861">
          <path
            d="M0 0L24 0L24 24L0 24L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath8746628861)">
        <path
          d="M-1 7.5L-1 0Q-1 -0.0984914 -0.980785 -0.19509Q-0.96157 -0.291689 -0.923879 -0.382683Q-0.886188 -0.473678 -0.83147 -0.55557Q-0.776751 -0.637463 -0.707107 -0.707107Q-0.637463 -0.776751 -0.55557 -0.831469Q-0.473678 -0.886188 -0.382683 -0.923879Q-0.291689 -0.961571 -0.19509 -0.980785Q-0.0984914 -1 0 -1Q0.267777 -1 0.499722 -0.866186L6.99972 2.88381L13.4997 6.63381Q13.585 6.68303 13.6591 6.74795Q13.7332 6.81286 13.7932 6.89098Q13.8531 6.9691 13.8967 7.05742Q13.9403 7.14574 13.9658 7.24087Q13.9914 7.336 13.9978 7.43428Q14.0043 7.53255 13.9915 7.63021Q13.9787 7.72786 13.947 7.82114Q13.9154 7.91441 13.8662 7.99972Q13.7321 8.23211 13.4997 8.36619L6.99972 12.1162L0.499723 15.8662Q0.414411 15.9154 0.321136 15.947Q0.227861 15.9787 0.130209 15.9915Q0.0325556 16.0043 -0.0657228 15.9978Q-0.164001 15.9914 -0.259128 15.9658Q-0.354256 15.9403 -0.442576 15.8967Q-0.530896 15.8531 -0.609016 15.7932Q-0.687135 15.7332 -0.752051 15.6591Q-0.816967 15.585 -0.866186 15.4997Q-1 15.2678 -1 15L-1 7.5ZM1 7.5L1 15L0 15L-0.499723 14.1338L6.00028 10.3838L12.5003 6.63381L13 7.5L12.5003 8.36619L6.00028 4.61619L-0.499722 0.866186L0 0L1 0L1 7.5Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 5.5 5)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default SinglePlayIcon;
